import {
  API,
  deleteRequest,
  getRequest,
  patchRequest,
  patchRequestBlob,
  postRequest,
  putRequest,
} from '@/api/api.ts';
import type {
  EventsProjectsResponse,
  EventsProjectResponse,
  CreateProjectRequest,
  UpdateProjectRequest,
  AddedUser,
} from '@/store/events/events-projects/events-projects.dto.ts';
import { invalidateAuthorizedFile } from '@/utils/file-links';

export const getAllEPs = async () => {
  return await getRequest<EventsProjectsResponse>(API.ACTIVITY, '/projects', false, {
    limit: 1000,
    page: 1,
  });
};

export const getCurrentEP = async (id: string) => {
  return await getRequest<EventsProjectResponse>(API.ACTIVITY, `/projects/${id}`);
};

export const createEP = async (eventProject: CreateProjectRequest) => {
  return await postRequest<EventsProjectResponse, CreateProjectRequest>(
    API.ACTIVITY,
    '/projects',
    eventProject,
  );
};

export const updateEP = async (id: string, eventProject: UpdateProjectRequest) => {
  return await putRequest<EventsProjectResponse, UpdateProjectRequest>(
    API.ACTIVITY,
    `/projects/${id}`,
    eventProject,
  );
};

export const deleteEP = async (id: string) => {
  return await deleteRequest(API.ACTIVITY, `/projects/${id}`);
};

export const addFileToEP = async (id: string, file: File) => {
  const form = new FormData();
  form.append('files', file);
  return await patchRequestBlob(API.ACTIVITY, `/projects/${id}/file`, form);
};

export const deleteFileFromEP = async (id: string, fileId: File) => {
  return await deleteRequest(API.ACTIVITY, `/projects/${id}/file/${fileId}`);
};

export const updateEPStatus = async (id: string, status: string) => {
  return await patchRequest(API.ACTIVITY, `/projects/${id}/status`, { status });
};

export const createEPChat = async (name: string, description: string, projectId: string) => {
  return await postRequest<
    { id: string },
    { name: string; description: string; project_id: string }
  >(API.CHAT, '/rooms', { name, description, project_id: projectId });
};

// Add if we would need to add chats to an event project
// export const addChatToEP = async (id: string, projectId: string) => {
//   return await patchRequest<{ id: string }, { project_id: string }>(
//     API.CHAT,
//     `/rooms/${id}/project`,
//     { project_id: projectId },
//   );
// };

export const addEPLogo = async (id: string, file: File) => {
  const formData = new FormData();
  formData.append('image', file);

  const response = await patchRequest(API.ACTIVITY, `/projects/${id}/cover-image`, formData);
  invalidateAuthorizedFile();

  return response;
};

export const addEPMembers = async (id: string, members: AddedUser[]) => {
  return await postRequest(API.ACTIVITY, `/projects/${id}/members`, { members });
};

export const removeEPMember = async (id: string, memberId: string) => {
  return await deleteRequest(API.ACTIVITY, `/projects/${id}/members/${memberId}`);
};
